export default __webpack_public_path__ + "static/media/zapIn.70916e5b.png";